import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
// import dropdown from '../json/user-dropdown.json';

import { logout } from '../actions/authActionCreators';

import '../css/elements/sidebar-heading-dropdown.css';

class SidebarHeadingDropdown extends Component {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  render() {
    const { name, referenceCode } = this.props;
    const userName = name.length > 16 ? `${name.slice(0, 15)}...` : name;
    return (
      <div className="sidebar-heading-dropdown">
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle className="btn btn-default btn-flat dropdown-toggle">
            <div className="name">{userName}</div>
            <div className="location">
              <i className="sli-globe" />
              <span>ERP, iBAN LATAM</span>
            </div>
            {referenceCode}
          </DropdownToggle>
          <DropdownMenu>
            {/* {dropdown.map((item, i) => (
              <DropdownItem key={i}>
                <i className={item.icon} />
                <span className="title">{item.name}</span>
                <div className="separator" />
                {item.badge && (
                  <span className={item.badgeClass}>{item.badgeText}</span>
                )}
              </DropdownItem>
            ))} */}
            <DropdownItem onClick={this.props.logout}>
              <i className="sli-power" />
              <span className="title">Cerrar sesión</span>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}
const mapStateToProps = state => {
  const { name, referenceCode } = state.user;
  return {
    name,
    referenceCode,
  };
};
export default connect(
  mapStateToProps,
  { logout }
)(SidebarHeadingDropdown);



// WEBPACK FOOTER //
// ./src/elements/SidebarHeadingDropdown.js